export default __webpack_public_path__ + "assets/models/1bd2371cf983a0daeb76517e77aed0e9.glb";